import { CountryOfIncorporationValues } from "./eligibility-constants";
import type { CurrencyCode } from "./eligibility-constants";
import { normalizeToUSD } from "./normalize-to-usd";

/** Maps a display country label to its eligibility currency code. */
const COUNTRY_LABEL_TO_CURRENCY: Record<string, CurrencyCode> = {
  [CountryOfIncorporationValues.US]: "USD",
  [CountryOfIncorporationValues.CA]: "CAD",
  [CountryOfIncorporationValues.GB]: "GBP",
  [CountryOfIncorporationValues.AU]: "AUD",
  [CountryOfIncorporationValues.IE]: "EUR",
  [CountryOfIncorporationValues.ES]: "EUR",
  [CountryOfIncorporationValues.NL]: "EUR",
  [CountryOfIncorporationValues.BE]: "EUR",
  [CountryOfIncorporationValues.DK]: "DKK",
  [CountryOfIncorporationValues.DE]: "EUR",
  [CountryOfIncorporationValues.SE]: "SEK",
  [CountryOfIncorporationValues.OTHER]: "USD",
  "New Zealand": "AUD",
};

export function getCurrencyCodeForCountryLabel(
  countryLabel: string
): CurrencyCode {
  return COUNTRY_LABEL_TO_CURRENCY[countryLabel] ?? "USD";
}

/** Same bucket strings as contact-us / eligibility funnel HubSpot fields. */
export function getHubSpotIbMonthlyReportedValue(
  revenue: number,
  currencyCode: CurrencyCode
): string {
  const revenueInUSD = normalizeToUSD(revenue, currencyCode);
  if (revenueInUSD <= 10_000) return "$0 - $10k";
  if (revenueInUSD <= 20_000) return "$10k - $20k";
  if (revenueInUSD <= 50_000) return "$20k - $50k";
  if (revenueInUSD <= 100_000) return "$50k - $100k";
  if (revenueInUSD <= 300_000) return "$100k - $300k";
  if (revenueInUSD <= 500_000) return "$300k - $500k";
  if (revenueInUSD <= 1_250_000) return "$500k - $1.25M";
  return "$1.25M+";
}
